class QuestionService {
  constructor(questions, types) {
    this.answers = {};
    this.questions = questions;
    this.types = types;
    this.currentQuestionNumber = 0;
  }

  getQuestionCount() {
    return this.questions.length;
  }

  getCurrentQuestionNumber() {
    return this.currentQuestionNumber;
  }

  getCurrentQuestion() {
    return this.questions[this.currentQuestionNumber];
  }

  hasNextQuestion() {
    return this.currentQuestionNumber + 1 < this.getQuestionCount();
  }

  hasPreviousQuestion() {
    return this.currentQuestionNumber > 0;
  }

  saveAnswer(answerIndex) {
    const question = this.getCurrentQuestion();

    if (question.answers[answerIndex] === undefined) {
      throw new Error(`Answer with index ${answerIndex} does not exist.`);
    }

    this.answers[this.currentQuestionNumber] = question.answers[answerIndex];

    if (this.hasNextQuestion()) {
      this.currentQuestionNumber += 1;
    }
  }

  undoAnswer() {
    if (this.hasPreviousQuestion()) {
      this.currentQuestionNumber -= 1;
    }
  }

  getAnswers() {
    if (this.currentQuestionNumber + 1 !== this.getQuestionCount()) {
      throw new Error('You have to answer all questions to retrieve answers.');
    }

    return this.answers;
  }

  getAnswersStatistics() {
    if (this.currentQuestionNumber + 1 !== this.getQuestionCount()) {
      throw new Error('You have to answer all questions to retrieve answers.');
    }

    const answersStatistics = {};

    this.types.forEach((type) => {
      answersStatistics[type] = 0;
    });

    Object.values(this.answers).forEach((answer) => {
      answersStatistics[answer.type] += 1;
    });

    return answersStatistics;
  }
}

export default QuestionService;
